export default "__VITE_ASSET__8a40e3ae__"